import classNames from "classnames";
import * as React from "react";
import { useCallback, useContext } from "react";
import { Button } from "reactstrap";
import { JobInfoContext } from "../../../job-info-context";
import { useResultsContext } from "../context/results-context";

type Props = {
  all?: boolean,
  className?: string,
  containerStyle?: React.HTMLAttributes<HTMLDivElement>['style'],
  buttonStyle?: React.HTMLAttributes<HTMLButtonElement>['style'],
}

export function PrintButton(props: Props) {

  // Context:
  const {jobInfo} = useContext(JobInfoContext);
  const {
    selectAllSections,
  } = useResultsContext();

  const jobStatus = jobInfo?.status;

  const handleClick = useCallback(() => {
    if (props.all) {
      selectAllSections();
    }
    setTimeout(() => window.print(), 0);
  }, [props.all, selectAllSections]);

  if (typeof jobStatus !== 'number') {
    return null;
  }
  return <div className={classNames('ll-print-container', props.className)} style={props.containerStyle}>
    <Button onClick={handleClick} style={props.buttonStyle}>
      Print {props.all ? 'report' : 'selected'}
    </Button>
  </div>
}

export default PrintButton;
